/*
 *   File : thank-you.js
 *   Author : https://evoqins.com
 *   Description : Onboarding thank-you page after mandatory investment
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";

import { Header } from "../../../Component/Navigation";
import { Footer } from "../../../Component/Footer";
import { PrimaryButton } from "../../../Component/Buttons";
import { _getProfile, _getSignupProgress } from "../../../Helper";
import Store from "../../../Store/store";

import PaymentSuccess from "../../../Assets/Images/success.webp";
import Loader from "../../../Assets/Images/loader-blue.gif";

import styles from "../../../Style/Component/login.module.scss";

const VALID_TYPES = ["PAYMENT_SUCCESS", "ORDER_SUCCESS"];

const STATUS_COPY = {
    PAYMENT_SUCCESS: {
        title: "Payment successful",
        description: "Your order is in the process, it will reflect in your account in T+3 days.",
    },
    ORDER_SUCCESS: {
        title: "Order successful",
        description: "SIP scheduled successfully",
    },
};

function ThankYou() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");

    const [loading, setLoading] = useState(true);
    const [paymentStatus, setPaymentStatus] = useState("");
    const [paymentDescription, setPaymentDescription] = useState("");

    useEffect(() => {
        const refresh_token = Cookies.get("refresh_token");
        const onboarding_refresh_token = Cookies.get("onboarding_refresh_token");

        if (refresh_token && !onboarding_refresh_token) {
            navigate("/", { replace: true });
            return;
        }

        if (!type || !VALID_TYPES.includes(type)) {
            navigate("/onboarding", { replace: true });
            return;
        }

        _getSignupProgress().then((response) => {
            if (response.status_code === 200) {
                const progressStatus = response.data?.signup_progress_text
                    || response.data?.signup_progress_status
                    || response.data?.kyc_data?.status;

                if (progressStatus !== "INVESTED" && progressStatus !== "ACCOUNT_CREATED") {
                    navigate("/onboarding", { replace: true });
                    return;
                }
            }

            const copy = STATUS_COPY[type];
            setPaymentStatus(copy.title);
            setPaymentDescription(copy.description);
            setLoading(false);
        });
    }, [type, navigate]);

    const _handleNavigateToHome = () => {
        let refresh_token = Cookies.get("onboarding_refresh_token");
        Cookies.remove("onboarding_refresh_token");
        Cookies.set("refresh_token", refresh_token, {
            domain: process.env.REACT_APP_DOMAIN,
            path: "/",
            expires: 30,
        });

        Store.dispatch({
            type: "UPDATE_REFRESH_TOKEN",
            payload: refresh_token,
        });

        Store.dispatch({
            type: "UPDATE_ONBOARDING_TOKEN",
            payload: { refresh_token: null, access_token: null },
        });

        navigate("/", { replace: true });
        _getProfile();
    };

    return (
        <section className="e-login-gradient">
            <Header />

            {
                loading ?
                    <div className="col-sm-10 col-md-9 col-lg-8 col-xl-7 mx-auto px-lg-0">
                        <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                            <div className="min-h-100vh text-center mt-5 pt-5">
                                <img src={Loader}
                                    className="object-fit-contain w-20 width-24px-res"
                                    draggable="false"
                                    alt="loader" />
                            </div>
                        </div>
                    </div>
                    :
                    <div className="col-sm-10 col-md-9 col-lg-8 col-xl-7 mx-auto px-md-0">
                        <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                            <div className={`${styles.e_onboarding_wrapper} e-border-radius-24 e-modal-box-shadow`}>
                                <div className="modal-gradient-bg d-flex flex-column align-items-center p-4 e-border-radius-24">
                                    <img className="img-fluid col-5 mt-4 pt-3"
                                        draggable={false}
                                        src={PaymentSuccess}
                                        alt="payment status image" />
                                    <p className="e-font-14-res text-center e-text-ufo-green e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                                        {paymentStatus}
                                    </p>
                                    <p className="e-font-12-res line-height-20px-res col-sm-10 mx-auto text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-0 mb-5">
                                        {paymentDescription}
                                    </p>

                                    <PrimaryButton name={"View Home"}
                                        className="padding-12px-tb col-8 mx-auto"
                                        onPress={_handleNavigateToHome} />
                                </div>
                            </div>
                        </div>
                    </div>
            }

            <div className="e-bg-anti-flash-white">
                <Footer auth={true} />
            </div>
        </section>
    );
}

export default ThankYou;
